export const EXPERIENCE = [
	{
		id: "EX1",
		jobTitle: "Front End Trainee",
		from: "itrax academy",
		date: `2-2022 3-2022`,
		info: ``,
	},
	{
		id: "EX2",
		jobTitle: "Trainee",
		from: "TIEC",
		date: `9-2020  10-2020`,
		info: "",
	},
];
